import { render, staticRenderFns } from "./TransactionHistoryComponent.vue?vue&type=template&id=71fb1660"
import script from "./TransactionHistoryComponent.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports